import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type IntegrationConnectionStrategyFragment = { connectionType: Types.IntegrationConnectionStrategyEnum, formFields?: Array<{ name: string, label: string, placeholder?: string | null, type: Types.FormComponentFieldTypeEnum }> | null, instructions?: { description?: string | null, instructionHtml?: string | null } | null };


export type IntegrationConnectionStrategyFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IntegrationConnectionStrategyFragmentDoc = /*#__PURE__*/ gql`
    fragment IntegrationConnectionStrategy on IntegrationConnectionStrategyType {
  connectionType
  formFields {
    name
    label
    placeholder
    type
  }
  instructions {
    description
    instructionHtml
  }
}
    `;